import { concat, defer, EMPTY, type Observable, of, Subject, tap } from 'rxjs'

/**
 * A request for the view, like focusing a field or scrolling to a card.
 * Requests are often made right after the element is created or revealed,
 * before its component mounts and subscribes, so the last request that no
 * subscriber took is delivered on subscription.
 */
export class ViewRequest {
  private readonly _requests = new Subject<void>()
  private _isPending = false

  /**
   * Emits for each request.
   */
  readonly request$: Observable<void> = defer(() =>
    concat(this._isPending ? of(undefined) : EMPTY, this._requests),
  ).pipe(
    tap(() => {
      this._isPending = false
    }),
  )

  /**
   * Asks the view, now or once it subscribes.
   */
  request() {
    this._isPending = true
    this._requests.next()
  }
}
